import { configureStore } from '@reduxjs/toolkit';
import { authReducer } from './auth/Reducers';

const store = configureStore({
    reducer: {
        auth: authReducer as any,
    },
    devTools: import.meta.env.MODE !== 'production',
});

export type AppState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default function createStore() {
    return store;
}
